<template>
  <div class="numCardEchart" :style="{height:height,width:width}" ref="numCardTotalEchart"></div>
</template>

<script>
import echarts from 'echarts'
import { setTimeout } from 'timers';
require('echarts/theme/macarons')  // echarts 马卡龙主题

export default {
  props: {
    width: {
      type: String,
      // default: '100%'
      // default: '144px'
      // default: '174px'
      default: '200px'
    },
    height: {
      type: String,
      // default: '340px'
      // default: '144px'
      default: '174px'
    }
  },
  data() {
    return {
      chart: null,
      serviceData: [],
      legendData: [],
      chartData:[]
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.numCardTotalEchart, 'macarons')
      // 饼图配置和数据
      var option = ({
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          left: 'center', // 水平居中
          bottom: '0',
          data: ['无']
          // data: ['可激活数', '已激活数', '已停机数', '本月到期']
        },
        calculable: false,
        color:['#1F78B4','#A6CEE3','#B2DF8A','#33A02C'],
        series: [
          {
            name: '号卡统计',
            type: 'pie',
            radius: [40, 60], // 圆心半径、半径
            center: ['50%', '40%'], // X轴、Y轴位置
            label: {
                normal: {
                    show: false,
                    // position: 'center'
                    position: 'inside'
                },
                emphasis: {
                    show: true,
                    textStyle: {
                        fontSize: '15',
                        fontWeight: 'bold'
                    }
                }
            },
            labelLine: { 
              normal: {
                  show: false // 不显示连接线
              }
            },
            data:[
              {value:0, name:'无'},
              // {value:310, name:'可激活数'},
              // {value:224, name:'已激活数'},
              // {value:335, name:'已停机数'},
              // {value:400, name:'本月到期'}
            ],
            animationEasing: 'cubicInOut',
            animationDuration: 2600,
            // avoidLabelOverlap: false,
          }
        ]
      })

      this.chart.setOption(option)
      window.onresize = this.chart.resize // 随屏幕的改变自适应大小
    },
    // 获取号卡统计数据渲染图形
    getDataAndDraw (serviceData, legendData) {
      // console.log('号卡统计数据渲染图形serviceData', serviceData)
      setTimeout(() => {
        this.chart.setOption({
          legend: [{
            data: legendData,
          }],
          series: [{
            data: serviceData,
          }]
        })
      }, 100);
      
    }
  },
  created () {
    // this.getDataAndDraw()
  },
  
}
</script>

<style scoped>
  .numCardEchart{
    /* width: 78%; */
    /* width: 100%; */
    height: 144px;
    margin-right: 15px;
  }
</style>
